<div class="quizgame-card" *ngIf="cardData">

  <ng-container *ngIf="!gameEnded">
    <div class="" *ngIf="!gameId">
      <div class="quizgame-card__start-slide">
        <div class="quizgame-card__title">
          <div class="quizgame-card__title-second" brtRoughText [type]="'highlight'" [state]="current ? 'run' : 'stop'">
            Einblicke-Quiz
          </div>
        </div>
        <div class="quizgame-card__intro-anim">
          <img src="/assets/img/insights-game-intro.svg" alt="Insights Game">
        </div>
        <div class="quizgame-card__intro-description">
          Gut aufgepasst? Beantworte drei Fragen richtig und erledige das Einblicke-Quiz
        </div>
        <div class="quizgame-card__button-wrapper">
          <button class="quizgame-card__button" (click)="startGame()">
            Quiz starten
          </button>
        </div>
      </div>
    </div>

    <div class="quizgame-card__question-slide" *ngIf="gameId">
      <div class="quizgame-card__time-wrapper">
        <div class="quizgame-card__time-line-outer">
          <div class="quizgame-card__time-line-inner" [ngClass]="{'running' : timeRunning, 'quizgame-card__time-line-inner--red' : timeLow}" [ngStyle]="{'width' : timePercentage + '%'}"> </div>
        </div>
        <div class="quizgame-card__time-label">
          {{getFormattedTime()}}
        </div>
      </div>
      <div class="quizgame-card__question-body">
        <div class="quizgame-card__question">
          {{ questionText }}
        </div>
        <div class="quizgame-card__answers">
          <ng-container *ngFor="let answer of answers" (click)="answerQuestion(answer.id)">

            <div class="quizgame-card__answer" (click)="answerQuestion(answer.id)" [ngClass]="{'quizgame-card__answer--selected' : selectedAnswerId === answer.id.toString(), 'quizgame-card__answer--correct' : correctAnswerId === answer.id.toString(), 'quizgame-card__answer--marked-incorrect' : (correctAnswerId.length) && (selectedAnswerId != correctAnswerId) && (selectedAnswerId === answer.id.toString()) }">
              {{ answer.text }}
            </div>

          </ng-container>
        </div>
      </div>
      <div class="quizgame-card__question-slide-footer">
        <div class="quizgame-card__abort-game-wrapper">

          <button class="quizgame-card__game-control quizgame-card__game-control--mobile" (click)="endGame()">Spiel beenden</button>
        </div>
        <div class="quizgame-card__question-slide-index">
          Frage {{ round }} von 3
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="gameEnded">
    <div class="quizgame-card__start-slide">

      <ng-container *ngIf="result === 'fail'">
        <div class="quizgame-card__title">
          <div class="quizgame-card__title-second" brtRoughText [type]="'highlight'" [state]="current ? 'run' : 'stop'">
            Oh nein!
          </div>
          <div class="quizgame-card__title-first">
            Versuche es noch einmal, um das Quiz abzuschließen!
          </div>
        </div>
        <div class="quizgame-card__button-wrapper">
          <button class="quizgame-card__button" (click)="startGame()">
            Quiz erneut starten
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="result === 'timeout'">
        <div class="quizgame-card__title">
          <div class="quizgame-card__title-second" brtRoughText [type]="'highlight'" [state]="current ? 'run' : 'stop'">
            Zeit abgeflaufen!
          </div>
          <div class="quizgame-card__title-first">
            Versuche es noch einmal, um das Quiz abzuschließen!
          </div>
        </div>
        <div class="quizgame-card__button-wrapper">
          <button class="quizgame-card__button" (click)="startGame()">
            Quiz erneut starten
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="result === 'manually-ended'">
        <div class="quizgame-card__title">
          <div class="quizgame-card__title-second" brtRoughText [type]="'highlight'" [state]="current ? 'run' : 'stop'">
            Spiel beendet!
          </div>
          <div class="quizgame-card__title-first">
            Versuche es später noch einmal, um das Quiz abzuschließen!
          </div>
        </div>
        <div class="quizgame-card__button-wrapper">
          <button class="quizgame-card__button" (click)="startGame()">
            Quiz erneut starten
          </button>
        </div>
      </ng-container>
      <ng-container *ngIf="result === 'success'">
        <div class="quizgame-card__title">
          <div class="quizgame-card__title-second" brtRoughText [type]="'highlight'" [state]="current ? 'run' : 'stop'">
            Gratuliere!
          </div>
          <div class="quizgame-card__title-first">
            Du hast das Quiz abgeschlossen!
          </div>



        </div>
        <div class="quizgame-card__intro-anim">
          <div class="quizgame-card__animation-container">
            <brt-dot-lottie [path]="'/assets/placeholder.lottie'" [autoplay]="false" [loop]="false" (instanceCreated)="onAnimCreated($event)"></brt-dot-lottie>
          </div>
        </div>
        <div class="quizgame-card__button-wrapper">
          <button class="quizgame-card__button" (click)="startGame()">
            Quiz erneut starten
          </button>
        </div>
      </ng-container>
    </div>
  </ng-container>


</div>
